module.exports = __webpack_public_path__ + "static/fairy-house-be4138aa35ff5a4d82ed5f8dd069f1f6.jpeg";